import { render, staticRenderFns } from "./out-of-stock.vue?vue&type=template&id=db1d2350&scoped=true"
import script from "./out-of-stock.vue?vue&type=script&lang=js"
export * from "./out-of-stock.vue?vue&type=script&lang=js"
import style0 from "./out-of-stock.vue?vue&type=style&index=0&id=db1d2350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1d2350",
  null
  
)

export default component.exports